import React from 'react';

import { AdaptiveTableCell } from '@components/common';

import { TNameTitle } from '@interfaces/common/common';

export const renderTitleOrNameCell = (getValue: () => unknown) => {
	const value = getValue();
	const { title = '', name = '' } = (value as TNameTitle) || {};
	const text = title || name || (typeof value === 'string' ? value : '');

	return <AdaptiveTableCell text={text} />;
};

export const renderSeverityCell = (getValue: () => unknown) => {
	const { title = '', color } = (getValue() as { title?: string; color?: string }) || {};

	return (
		<AdaptiveTableCell
			color={color}
			text={title}
		/>
	);
};

export const renderUsersCell = (getValue: () => unknown) => {
	const users = (getValue() as Array<{ name?: string }>) || [];
	const usersNames = users.map((user) => user?.name).join(', ');

	return <AdaptiveTableCell text={usersNames} />;
};
